
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Notify from 'vue-notification';
import u from '@/utility/utility';
import { Cart } from '@/models/cart';

@Component({
    components: {
        Loading,
    },
})
export default class ListCart extends Vue {
    private eventEmit = {
        eventQuantityChange: 'eventQuantityChange',
        eventFeeShipChange: 'eventFeeShipChange',
        eventFragileGoodsChange: 'eventFragileGoodsChange',
        eventChooseCart: 'eventChooseCart',
        eventChooseProduct: 'eventChooseProduct',
        eventCommentChange: 'eventCommentChange',
        eventChangeDescription: 'eventChangeDescription',
        eventDeleteItem: 'eventDeleteItem',
        eventDeleteCart: 'eventDeleteCart',
    };

    @Prop({default: null})
    private cartItem!: Cart;

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }

    private onQuantityChange(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventQuantityChange, emitData);
    }

    private onQuantityKeyDown(e: any) {
        if (e.key === '.') {
            e.preventDefault();
        }
        return;
    }

    private onFeeShipChange() {
        const emitData = {
            cartItem: this.cartItem,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventFeeShipChange, emitData);
    }

    private onFragileGoodsChange() {
        const emitData = {
            cartItem: this.cartItem,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventFragileGoodsChange, emitData);
    }

    private onCommentChange(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };

        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventCommentChange, emitData);
    }

    private onChangeDescription() {
        const emitData = {
            cartItem: this.cartItem,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventChangeDescription, emitData);
    }

    private onDeleteItem(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };

        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventDeleteItem, emitData);
    }

    private onDeleteCart() {
        const emitData = {
            cartItem: this.cartItem,
        };

        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventDeleteCart, emitData);
    }

    private onChooseCart() {
        const emitData = {
            cartItem: this.cartItem,
        };

        this.$emit(this.eventEmit.eventChooseCart, emitData);
    }

    private onChooseProduct(product) {
        const emitData = {
            product,
            cartId: this.cartItem.id
        };

        this.$emit(this.eventEmit.eventChooseProduct, emitData);
    }

    private orderCart() {
        if (this.cartItem.isChoose) {
            const emitData = {
                ...this.cartItem,
                products: this.cartItem.products.filter(x => x.isChoose === true),
            };
            (window['getApp'] as any).$emit('SET_SELECTED_CART', emitData);
            this.$router.push({ name: 'cart-confirm-cart' });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy chọn sản phẩm cần Order!',
            });
            (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
        }
        
    }
}
